import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLoeschen = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "28px",
	height: "29px",
	viewBox: "0 0 28 29",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Unvollst\\xE4ndige-Bewertungen",
			transform: "translate(-1000.000000, -225.000000)",
			fill: "#F8B477",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-4",
				transform: "translate(138.000000, 213.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "delete",
					transform: "translate(862.000000, 12.000000)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M19.448844,29.0000026 L8.54995065,29.0000026 C6.28833603,28.9670785 4.43323623,27.1867805 4.29257044,24.9142844 L3.00116511,5.14286207 C2.98779172,4.85331868 3.08998624,4.57041348 3.28499046,4.35714804 C3.4859681,4.13603415 3.76786917,4.00704456 4.06551016,4.00000264 L23.9332845,4.00000264 C24.2283016,3.99934455 24.510357,4.12197822 24.7121318,4.33863704 C24.9139067,4.55529585 25.0172981,4.84654164 24.9976295,5.14286207 L23.7629893,24.9142844 C23.6207377,27.2085625 21.7323877,28.9969251 19.448844,29.0000026 Z M5.25757662,6.14286175 L6.35030421,24.785713 C6.42523746,25.9525114 7.38844882,26.8595766 8.54995065,26.8571458 L19.448844,26.8571458 C20.6075926,26.8525664 21.5667921,25.9492791 21.6484904,24.785713 L22.7979831,6.2142903 L5.25757662,6.14286175 Z",
							id: "Shape"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M26.9230769,6 L1.07692305,6 C0.482154866,6 0,5.55228474 0,5 C0,4.44771526 0.482154866,4 1.07692305,4 L26.9230769,4 C27.5178451,4 28,4.44771525 28,5 C28,5.55228475 27.5178451,6 26.9230769,6 L26.9230769,6 Z",
							id: "Path"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M17.8999997,6 L9.09999997,6 C8.49578896,5.99281892 8.00789919,5.54928275 8,5 L8,2.6 C8.03861652,1.17885496 9.29674042,0.0351059273 10.8599999,0 L16.1399998,0 C17.7313259,0.0361777406 19.0004972,1.21955429 19,2.66666667 L19,5 C18.9921005,5.54928275 18.5042107,5.99281892 17.8999997,6 L17.8999997,6 Z M10.1999999,4 L16.7999998,4 L16.7999998,2.66666667 C16.7999998,2.33529582 16.5045077,2.06666667 16.1399998,2.06666667 L10.8599999,2.06666667 C10.495492,2.06666667 10.1999999,2.33529582 10.1999999,2.66666667 L10.1999999,4 Z",
							id: "Shape"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M18,23 C17.4507172,22.9926299 17.0071811,22.5374218 17,21.9736842 L17,11.0263158 C17,10.4594972 17.4477153,10 18,10 C18.5522847,10 19,10.4594972 19,11.0263158 L19,21.9736842 C18.9928189,22.5374218 18.5492828,22.9926299 18,23 Z",
							id: "Path"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M10,23 C9.45071725,22.9926299 9.00718108,22.5374218 9,21.9736842 L9,11.0263158 C9,10.4594972 9.44771525,10 10,10 C10.5522847,10 11,10.4594972 11,11.0263158 L11,21.9736842 C10.9928189,22.5374218 10.5492828,22.9926299 10,23 L10,23 Z",
							id: "Path"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M14,23 C13.4507172,22.9926299 13.0071811,22.5374218 13,21.9736842 L13,11.0263157 C13,10.4594972 13.4477153,10 14,10 C14.5522847,10 15,10.4594972 15,11.0263157 L15,21.9736842 C14.9928189,22.5374218 14.5492828,22.9926299 14,23 L14,23 Z",
							id: "Path"
						})
					]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconLoeschen);
export { ForwardRef as ReactComponent };
